// firebase.ts
import { initializeApp, FirebaseApp } from 'firebase/app';
import { getFirestore, enableIndexedDbPersistence, Firestore } from 'firebase/firestore';
import { getAuth, Auth } from 'firebase/auth';
import { getStorage, FirebaseStorage } from "firebase/storage" // <-- importe o Storage

// Configuração do Firebase usando variáveis de ambiente
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Inicializar Firebase apenas se as variáveis estiverem configuradas
let app: FirebaseApp | undefined;
let db: Firestore | undefined;
let auth: Auth | undefined;
let storage: FirebaseStorage | undefined;

if (firebaseConfig.apiKey && firebaseConfig.projectId) {
  try {
    app = initializeApp(firebaseConfig);
    db = getFirestore(app);
    auth = getAuth(app);
    storage = getStorage(app);
  } catch (error) {
    // Silenciosamente ignora erros de inicialização se não estiver configurado
    console.warn('Firebase não configurado ou erro na inicialização');
  }
}

// Ativar persistência offline (para melhorar a experiência do usuário e reduzir erros de conexão)
if (db) {
  enableIndexedDbPersistence(db)
    .catch((err) => {
      if (err.code === 'failed-precondition') {
        // Múltiplas abas abertas, persistência só pode ser ativada em uma aba por vez
        console.warn('Persistência do Firestore não pôde ser ativada: múltiplas abas abertas');
      } else if (err.code === 'unimplemented') {
        // O navegador atual não suporta os recursos necessários
        console.warn('Persistência do Firestore não é suportada neste navegador');
      }
    });
}

// Exportar Storage e outros serviços
export { db, auth, storage };
